import {
  DetailHeader,
  DetailHeaderRow,
  DetailHeaderSection,
} from 'components/DetailHeader/DetailHeader';
import React, { type FC } from 'react';
import { formatDateTime } from 'utils/date';

import { LinkIcon } from '@fragment/ui/src/components/Icon/LinkIcon/LinkIcon';

import { type LinkNode } from './types';

type LinkSummaryProps = {
  link: LinkNode;
  /** Makes the Link row open this path instead of copying the name. */
  detailsHref: string | undefined;
};

export const LinkSummary: FC<LinkSummaryProps> = ({ link, detailsHref }) => {
  let env: string | undefined;
  if (link.__typename === 'IncreaseLink') {
    env = link.increaseEnv;
  } else if (link.__typename === 'UnitLink') {
    env = link.unitEnv;
  } else if (link.__typename === 'StripeLink') {
    env = link.stripeEnv;
  }

  return (
    <DetailHeader>
      <DetailHeaderSection>
        <DetailHeaderRow
          label="Link"
          value={
            <div className="flex items-center">
              <LinkIcon type={link.__typename} />
              {link.name}
            </div>
          }
          {...(detailsHref
            ? { linkHref: detailsHref }
            : { textToCopy: link.name })}
        />
        <DetailHeaderRow label="ID" value={link.id} textToCopy={link.id} />
        {env ? (
          <DetailHeaderRow label="Environment" value={<span>{env}</span>} />
        ) : null}

        <DetailHeaderRow
          label="Created"
          value={link.created ? formatDateTime(link.created) : 'N/A'}
          textToCopy={link.created}
        />
      </DetailHeaderSection>
    </DetailHeader>
  );
};
